/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_BodyInputs */

const en_road_dude_clips_body = /** @type {(inputs: Road_Dude_Clips_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch with sound. A pause, a look out the window and a gesture down the road are enough to carry the joke into a new scene.`)
};

const zh_road_dude_clips_body = /** @type {(inputs: Road_Dude_Clips_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开声音观看。停顿一下、望向车窗外，再朝路口一指，换了角色和场景，笑点依然成立。`)
};

/**
* | output |
* | --- |
* | "Watch with sound. A pause, a look out the window and a gesture down the road are enough to carry the joke into a new scene." |
*
* @param {Road_Dude_Clips_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_body = /** @type {((inputs?: Road_Dude_Clips_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_body(inputs)
	return zh_road_dude_clips_body(inputs)
});
export { road_dude_clips_body as "road_dude.clips.body" }